/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsSummaryDto } from '../../models/analytics-summary-dto';

export interface SuperadminControllerGetAnalyticsSummary$Params {

/**
 * Inclusive ISO date. Defaults to 30 days ago.
 */
  from?: string;

/**
 * Exclusive ISO date. Defaults to tomorrow.
 */
  to?: string;
}

export function superadminControllerGetAnalyticsSummary(http: HttpClient, rootUrl: string, params?: SuperadminControllerGetAnalyticsSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetAnalyticsSummary.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnalyticsSummaryDto>;
    })
  );
}

superadminControllerGetAnalyticsSummary.PATH = '/superadmin/analytics/summary';
